/** @format */

// API Base URL - Use environment variable for all environments
// In CI/CD, REACT_APP_API_URL is injected at build time
export const API_BASE_URL =
	process.env.REACT_APP_SERVER_URI ||
	process.env.REACT_APP_LOCAL_SERVER_URI ||
	"http://localhost:8080";

// WebSocket URL - Use environment variable for all environments
// In CI/CD, REACT_APP_WEBSOCKET_URL is injected at build time
export const WEB_SOCKET_URL =
	process.env.REACT_APP_WEBSOCKET_URL ||
	process.env.REACT_APP_LOCAL_WEB_SOCKET_SERVER_URI ||
	"wss://forus.one";

// Stripe Plan ID - Use environment variable
export const STRIPE_PLAN_ID =
	process.env.REACT_APP_STRIPE_PLAN_ID ||
	process.env.REACT_APP_STRIPE_TEST_MODE_PLAN_ID ||
	"";

// Alias for backwards compatibility
export const STRIPE_TEST_MODE_PLANID = STRIPE_PLAN_ID;
